// domain/visita.js  (entidad + mapeos). Sin React, sin Api, sin Swal, sin localStorage/window.
import { toApiDate } from '../../shared/domain/fecha';
import { ultimoAsistenteActivo } from '../../shared/domain/asistentes';

// El uuid (y la fecha por defecto) los provee la capa application: el dominio queda determinista.
export const emptyVisita = {
  id: null,
  uuid: '',
  created_at: null,
  motivo: '',
  fecha: '',
  id_parcela: null,
  id_ciclo: null,
  id_user: null,
  observaciones: '',
  asistentes: [],
  media: [],
};

const toId = value => {
  if (value === null || value === undefined || value === '') return null;
  const n = Number(value);
  return isNaN(n) ? null : n;
};

export const createVisita = (data = {}) => ({
  ...emptyVisita,
  ...data,
  fecha: toApiDate(data.fecha),
  id_parcela: toId(data.id_parcela),
  id_ciclo: toId(data.id_ciclo),
  id_user: toId(data.id_user),
  observaciones: data.observaciones || '',
});

// DTO del backend -> entidad (asistentes/media vienen solo en el detalle)
export const fromApi = dto =>
  createVisita({
    id: toId(dto.id),
    uuid: dto.uuid,
    created_at: dto.created_at || null,
    motivo: dto.motivo || '',
    fecha: dto.fecha,
    id_parcela: dto.id_parcela,
    id_ciclo: dto.id_ciclo,
    id_user: dto.id_user,
    observaciones: dto.observaciones,
    asistentes: Array.isArray(dto.asistentes) ? dto.asistentes : [],
    media: Array.isArray(dto.media) ? dto.media : [],
  });

const OPTIONAL_FIELDS = ['id_parcela', 'id_ciclo', 'observaciones'];
const isEmpty = value => value === null || value === undefined || value === '';

/**
 * entidad -> payload del backend.
 * Al crear (`includeEmpty: false`) se omiten los opcionales vacíos; al actualizar (`true`) se envían
 * como null para poder limpiar un valor. `uuid` solo va en la creación. `asistentes` (opcional) viaja en el mismo payload.
 */
export const toApiPayload = (visita, { includeEmpty = false, asistentes } = {}) => {
  const payload = {
    motivo: visita.motivo.trim(),
    fecha: toApiDate(visita.fecha),
  };
  if (!includeEmpty) payload.uuid = visita.uuid;
  // Lista FINAL [{ uuid, id_cuenta }] (el backend la reconcilia por uuid); si no se pasa, el backend no toca los asistentes.
  if (asistentes !== undefined) payload.asistentes = asistentes;
  OPTIONAL_FIELDS.forEach(field => {
    const raw = visita[field];
    const value = typeof raw === 'string' ? raw.trim() : raw;
    if (!isEmpty(value)) payload[field] = value;
    else if (includeEmpty) payload[field] = null;
  });
  return payload;
};

/**
 * La visita no tiene campo productor: el productor visitado es su (único) asistente en at_asistentes.
 * Devuelve el id de cuenta del asistente vigente más reciente, o null.
 */
export const idProductor = visita => {
  const asistente = ultimoAsistenteActivo(visita.asistentes);
  return asistente && Number(asistente.id_cuenta) ? Number(asistente.id_cuenta) : null;
};
